export const channelColors: string[] = [
  '#ffa39e', '#ffe58f', '#b7eb8f', '#adc6ff',
  '#ffbb96', '#fffb8f', '#87e8de', '#d3adf7',
  '#ffd591', '#eaff8f', '#91d5ff', '#ffadd2',
  '#a8071a', '#ad6800', '#237804', '#10239e',
  '#ad2102', '#ad8b00', '#006d75', '#391085',
  '#ad4e00', '#5b8c00', '#0050b3', '#9e1068',
]